import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast';
import clsx from 'clsx'
import { Button, Card, Error, FancyInput } from 'components/ui'
import { LoginFormData } from 'ts/types'
import useAuthStore from 'store/auth'

const SignInPage = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<LoginFormData>()
  const { signIn, isLoading, error } = useAuthStore()
 
  async function onSubmit(formData: LoginFormData) {
    const res = await signIn(formData)
    if (!res){
      reset()
    } else {
      toast.success("Successfully logged in")
    }
  }

  return (
    <div className="flex flex-col h-screen">
      <div className="flex flex-1 mx-auto">
        {error ? <Error data={error} /> : null}
      </div>

      <div className="mx-auto h-3/4">
        <Card className="p-10">
          <h1 className="mb-8 text-2xl font-medium text-center text-gray-500">
            Sign In
          </h1>

          <form
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col"
          >
            <FancyInput
              {...register('login', { required: true })}
              className={clsx(
                'border mb-4',
                errors.login ? 'border-red-500' : 'border-transparent'
              )}
              placeholder="Username"
              autoFocus
            />

            <FancyInput
              {...register('password', { required: true })}
              className={clsx(
                'border mb-4',
                errors.password ? 'border-red-500' : 'border-transparent'
              )}
              placeholder="Password"
              type="password"
            />

            <Button isLoading={isLoading}>Submit</Button>
          </form>
        </Card>
      </div>
    </div>
  )
}

export default SignInPage
